import APICaller, { POST } from "../apiCaller";
import DashboardURLs from "./urls";

function searchTickers(input) {
  return APICaller(POST, DashboardURLs.searchTickers,{input});
}
function getSentimentGraphData(ticker,timeRange){
  return APICaller(POST, DashboardURLs.getSentimentGraphData,{ticker,timeRange});
}
function getMentionsGraphData(ticker,timeRange){
  return APICaller(POST, DashboardURLs.getMentionsGraphData,{ticker,timeRange});
}
const DashboardService = {
  searchTickers,
  getSentimentGraphData,
  getMentionsGraphData
};

export default DashboardService;
